import { SearchInterface, QueryStateModel } from 'coveo-search-ui';

export function isTabCurrentlySelected(selected: string, searchInterface: SearchInterface): boolean {
    return !(!!selected && selected !== searchInterface.queryStateModel.get(QueryStateModel.attributesEnum.t));
}
